import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bf82422"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = { id: "metadata8" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("image/svg+xml")
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<defs id=\"defs6\" data-v-4bf82422></defs><g transform=\"matrix(1.3333333,0,0,-1.3333333,0,441.33333)\" id=\"g10\" data-v-4bf82422><g transform=\"scale(0.1)\" id=\"g12\" data-v-4bf82422><path id=\"path14\" style=\"fill:#2873ab;fill-opacity:1;fill-rule:nonzero;stroke:none;\" d=\"M 65.2422,2178.75 775.242,1915 773.992,15 65.2422,276.25 v 1902.5\" data-v-4bf82422></path><path id=\"path16\" style=\"fill:#2873ab;fill-opacity:1;fill-rule:nonzero;stroke:none;\" d=\"m 804.145,2640.09 c 81.441,-240.91 -26.473,-436.2 -241.04,-436.2 -214.558,0 -454.511,195.29 -535.9527,436.2 -81.4335,240.89 26.4805,436.18 241.0387,436.18 214.567,0 454.512,-195.29 535.954,-436.18\" data-v-4bf82422></path><path id=\"path18\" style=\"fill:#ed1d33;fill-opacity:1;fill-rule:nonzero;stroke:none;\" d=\"M 1678.58,2178.75 968.578,1915 969.828,15 1678.58,276.25 v 1902.5\" data-v-4bf82422></path><path id=\"path20\" style=\"fill:#ed1d33;fill-opacity:1;fill-rule:nonzero;stroke:none;\" d=\"m 935.082,2640.09 c -81.437,-240.91 26.477,-436.2 241.038,-436.2 214.56,0 454.51,195.29 535.96,436.2 81.43,240.89 -26.48,436.18 -241.04,436.18 -214.57,0 -454.52,-195.29 -535.958,-436.18\" data-v-4bf82422></path><path id=\"path22\" style=\"fill:#2873ab;fill-opacity:1;fill-rule:nonzero;stroke:none;\" d=\"m 1860.24,2178.75 710,-263.75 -1.25,-1900 -708.75,261.25 v 1902.5\" data-v-4bf82422></path><path id=\"path24\" style=\"fill:#2873ab;fill-opacity:1;fill-rule:nonzero;stroke:none;\" d=\"m 2603.74,2640.09 c 81.45,-240.91 -26.47,-436.2 -241.03,-436.2 -214.58,0 -454.52,195.29 -535.96,436.2 -81.44,240.89 26.48,436.18 241.03,436.18 214.57,0 454.51,-195.29 535.96,-436.18\" data-v-4bf82422></path><path id=\"path26\" style=\"fill:#ed1d33;fill-opacity:1;fill-rule:nonzero;stroke:none;\" d=\"m 3700.24,3310 v -652.5 c 0,0 -230,90 -257.5,-142.5 -2.5,-247.5 0,-336.25 0,-336.25 l 257.5,83.75 V 1690 l -258.61,-92.5 V 262.5 L 2735.24,0 v 2360 c 0,0 -15,850 965,950\" data-v-4bf82422></path></g></g>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dc58format = _resolveComponent("dc:format")!
  const _component_dc58type = _resolveComponent("dc:type")!
  const _component_cc58Work = _resolveComponent("cc:Work")!
  const _component_rdf58RDF = _resolveComponent("rdf:RDF")!

  return (_openBlock(), _createElementBlock("svg", {
    class: "icon-iiif",
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:cc": "http://creativecommons.org/ns#",
    "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "xmlns:svg": "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 493.35999 441.33334",
    width: _ctx.px,
    height: _ctx.px,
    "xml:space": "preserve",
    id: "svg2",
    version: "1.1"
  }, [
    _createElementVNode("metadata", _hoisted_2, [
      _createVNode(_component_rdf58RDF, null, {
        default: _withCtx(() => [
          _createVNode(_component_cc58Work, { "rdf:about": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_dc58format, null, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_dc58type, { "rdf:resource": "http://purl.org/dc/dcmitype/StillImage" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_4
  ], 8, _hoisted_1))
}